<div
  class={MoveListShared.Classes.MoveInfoIcon}
  bind:this={iconWrapper}
  data-tooltip={tooltipMessage}
  data-tooltip-position={rect && tooltipTop()}
  style={`--tooltip-top:${(rect && rect.y) || 1}px`}
  on:click={handleClick}
  on:mouseover={positionTooltip}
>
  <span class={`${MoveListShared.Classes.IconFont} ${iconClassName}`} />
</div>

<script lang="ts">
import type { TooltipProps } from 'components/move-list/helpers/get-tooltip-props';
import { MoveListShared } from 'components/move-list-shared/config/types';

export let tooltipMessage: TooltipProps['tooltipMessage'];
export let handleClick: TooltipProps['handleClick'] = () => {};
export let iconClassName: TooltipProps['iconClassName'];

let iconWrapper: HTMLDivElement;
let rect: DOMRect;

/**
 * positions the tooltip
 */
function positionTooltip() {
  rect = iconWrapper.getBoundingClientRect();
}

/**
 * returns the tooltip position type
 */
function tooltipTop() {
  if (rect.y > window.innerHeight / 2) {
    return 'top';
  }
  return undefined;
}
</script>
